import React from 'react';
import { S } from './style';
export default function Label({ title }) {
    return <S.Layout>{title}</S.Layout>;
}
